import React from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'

export const Delete = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props} viewBox="0 0 24 24">
      <path
        fillRule="nonzero"
        d="M10.286 9.714c-.343 0-.572.229-.572.572V16c0 .343.229.571.572.571.343 0 .571-.228.571-.571v-5.714c0-.343-.228-.572-.571-.572Z"
      />
      <path
        fillRule="nonzero"
        d="M19.429 6.286h-4v-.572c0-.971-.743-1.714-1.715-1.714h-3.428c-.972 0-1.715.743-1.715 1.714v.572h-4c-.342 0-.571.228-.571.571 0 .343.229.572.571.572h1.143v10.857c0 .971.743 1.714 1.715 1.714h9.142c.972 0 1.715-.743 1.715-1.714V7.429h1.143c.342 0 .571-.229.571-.572 0-.343-.229-.571-.571-.571Zm-9.715-.572c0-.343.229-.571.572-.571h3.428c.343 0 .572.228.572.571v.572H9.714v-.572Zm7.429 12.572c0 .343-.229.571-.572.571H7.43c-.343 0-.572-.228-.572-.571V7.429h10.286v10.857Z"
      />
      <path
        fillRule="nonzero"
        d="M13.714 9.714c-.343 0-.571.229-.571.572V16c0 .343.228.571.571.571.343 0 .572-.228.572-.571v-5.714c0-.343-.229-.572-.572-.572Z"
      />
    </SvgIcon>
  )
}
